<button class="btn btn-filter btn-toggle h-full" [matMenuTriggerFor]="filterRoleMenu" [ngClass]="{ 'active': selectedItems().length > 0 }">
    <app-svg [name]="selectedItems().length === 1 ? valueToIconMap[selectedItems()[0]] : 'lock'" [color]="selectedItems().length > 0 ? ss.theme().color12 : ss.theme().color7" class="me-2" style="height: 15px; width: 15px;"></app-svg>
    <span>{{ getLabel() }}</span>

    <div class="clear-icon ri-ms-2" *ngIf="selectedItems().length > 0" role="button" (click)="selectedItems.set([]); value.set([]);$event.stopPropagation()">
        <app-svg class="d-flex align-items-center justify-content-center" name="close" [color]="ss.theme().color1"></app-svg>
    </div>
</button>

<mat-menu yPosition="above" xPosition="before" #filterRoleMenu="matMenu" class="me-menu ri-w-350px">
    <ng-container *ngFor="let status of entityFilterRole; let i = index;">
        <button mat-menu-item *ngIf="!hiddenValues.includes(status)" (click)="onRoleSelected(status, $event)">
            <span class="text-14-400 color-8 flex items-center justify-between">
                <div class="flex items-center">
                    <app-svg [name]="valueToIconMap[status]" [color]="ss.theme().color35" class="ri-me-4"></app-svg>
                    <span>{{ entityRoleMap()[status] }}</span>
                </div>
                <app-input-checkbox [checked]="selectedItems().includes(status)"></app-input-checkbox>
            </span>
        </button>
    </ng-container>
</mat-menu>